import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Api from './views/Api.vue'
import UserSignIn from './views/UserSignIn.vue'
import UserRegister from './views/UserRegister.vue'
import UserForgotPassword from './views/UserForgotPassword.vue'
import UserConfirmEmail from './views/UserConfirmEmail.vue'
import UserNewPassword from './views/UserNewPassword.vue'
import UserPasswordSent from './views/UserPasswordSent.vue'
import StyleGuide from './views/StyleGuide.vue'
import UserAccount from './views/UserAccount.vue'
import UserBilling from './views/UserBilling.vue'
import UploadLeads from './views/UploadLeads.vue'
import Lookup from './views/Lookup.vue'
import Email from './views/Email.vue'
import Csv from './views/Csv.vue'
import Developer from './views/Developer.vue'
import Integration from './views/Integration.vue'

import store from './store'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: 'upload_leads',
      component: UploadLeads,
      meta: { requiresLogin: true }
    },
    {
      path: '/csv/:id',
      name: 'csv_details',
      component: Csv,
      meta: { requiresLogin: true }
    },
    {
      path: '/api',
      name: 'api',
      component: Api
    },
    {
      path: '/lookup',
      name: 'lookup',
      component: Lookup,
      meta: { requiresLogin: true }
    },
    {
      path: '/user/login',
      name: 'login',
      component: UserSignIn,
      meta: { requiresLogin: false, login: true }
    },
    {
      path: '/user/forgot_password',
      name: 'forgot_password',
      component: UserForgotPassword,
      meta: { requiresLogin: false }
    },
    {
      path: '/user/password_sent/:email',
      name: 'password_sent',
      component: UserPasswordSent,
      meta: { requiresLogin: false }
    },
    {
      path: '/user/new_password/:password_secret_key',
      name: 'new_password',
      component: UserNewPassword,
      meta: { requiresLogin: false }
    },
    {
      path: '/user/confirm_email/:confirm_email_key',
      name: 'confirm_email',
      component: UserConfirmEmail,
      meta: { requiresLogin: false }
    },
    {
      path: '/email',
      name: 'email',
      component: Email,
      meta: { requiresLogin: true }
    },
    // eslint-disable-next-line spaced-comment
    /*{
      path: '/send_email',
      name: 'send_email',
      component: SendEmail,
      meta: { requiresLogin: true }
    }, */
    {
      path: '/user/register',
      name: 'register',
      component: UserRegister,
      meta: { requiresLogin: false, login: true }
    },
    {
      path: '/user/account',
      name: 'account',
      component: UserAccount,
      meta: { requiresLogin: true }
    },
    {
      path: '/user/developer',
      name: 'developer',
      component: Developer,
      meta: { requiresLogin: true }
    },
    {
      path: '/user/integration',
      name: 'integration',
      component: Integration,
      meta: { requiresLogin: true }
    },
    {
      path: '/user/billing',
      name: 'billing',
      component: UserBilling,
      meta: { requiresLogin: true }
    },
    {
      path: '/styleguide',
      name: 'StyleGuide',
      component: StyleGuide,
      meta: { requiresLogin: true }
    },
    {
      path: '*',
      name: '404',
      component: UploadLeads,
      redirect: { name: 'upload_leads' },
      meta: { requiresLogin: false }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresLogin)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.state.user.authenticated) {
      if (to.query) {
        next({ name: 'register', query: to.query })
      } else {
        next({ name: 'register' })
      }
    } else {
      if (store.state.user.data && !store.state.user.data.email_verified && to.name !== 'email') {
        next({ name: 'email' })
      } else {
        next()
      }
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
